import React, { useState, useEffect } from "react";

const SimListDropDown = ({ menuData, setActiveTab }) => {
  const [activeDropdown, setActiveDropdown] = useState(0);
  const [activeSubmenu, setActiveSubmenu] = useState(0);

  useEffect(() => {
    const defaultActive = {};
    menuData
      .filter((e) => e.hasDropdown == true && e.submenu.length > 0)
      .forEach((item, index) => {
        defaultActive[index] = 0;
      });
    setActiveSubmenu(defaultActive);
    setActiveSubmenu(0);
  }, [menuData]);

  const toggleDropdown = (index) => {
    setActiveDropdown(index);
    setActiveSubmenu(0);
    setActiveTab(menuData[index].id_link);
  };

  const toggleSubmenu = (menuIndex, submenuIndex, submenuId) => {
    setActiveTab(submenuId);
    setActiveSubmenu(submenuIndex);
  };

  return (
    <div className="listwithdropdown">
      <ul className="menu">
        {menuData.map((item, index) => (
          <li key={index} className={item.hasDropdown ? "dropdown" : "withoutdropdown"}>
            <span
              className={`listmenu ${activeDropdown === index ? "active" : ""}`}
              onClick={() => toggleDropdown(index)}
            >
              {item.icon}
              {item.title}
            </span>
            {item.hasDropdown && activeDropdown === index && (
              <ul className="submenu">
                {item.submenu.map((subitem, subindex) => (
                  <li
                    key={subindex}
                    className={`submenulist ${activeSubmenu === subindex ? "active" : ""}`}
                    onClick={() => toggleSubmenu(index, subindex, subitem.id_link)}
                  >
                    <span className="submenuname">{subitem.title}</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SimListDropDown;
